const CancelOrderPage: React.FC = () => {
  return (
    <p className="text-base leading-5 text-gray-900">
      Are you sure you want to do this? You will exit without saving your order.
    </p>
  );
};
export default CancelOrderPage;
